/**
 * c-hero.js — Hero Section popup close behavior
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var popups = document.querySelectorAll('[data-hero-popup]');
    if (!popups.length) return;

    popups.forEach(function (popup) {
      var closeBtn = popup.querySelector('[data-hero-popup-close]');
      if (!closeBtn) return;

      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    });
  });
})();
